import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Navbar.css";

function Navbar() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  const translations = {
    en: {
      title: "Driving Theory Test Bangla",
      signup: "Sign up",
      login: "Login",
      logout: "Logout",
      hi: "Hi",
      premium: "Premium",
    },
    bn: {
      title: "ড্রাইভিং থিওরি টেস্ট বাংলা",
      signup: "সাইন আপ",
      login: "লগইন",
      logout: "লগআউট",
      hi: "হ্যালো",
      premium: "প্রিমিয়াম",
    },
  };

  const [lang, setLang] = useState(localStorage.getItem("lang") || "en");

  const handleLangToggle = () => {
    const newLang = lang === "en" ? "bn" : "en";
    localStorage.setItem("lang", newLang);
    setLang(newLang);
    window.location.reload();
  };

  const fetchUserProfile = () => {
    const token = localStorage.getItem("jwtToken");
    if (!token) {
      setUser(null);
      localStorage.removeItem("isPremium"); // Clear premium state if not logged in
      return;
    }
    /* console.log(process.env.REACT_APP_API_URL); */

    fetch(`${process.env.REACT_APP_API_URL}/profile`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (!data.error) {
          setUser(data.data);
          localStorage.setItem(
            "isPremium",
            data.data.is_premium ? "true" : "false",
          );
        } else {
          setUser(null);
          localStorage.removeItem("isPremium");
        }
      })
      .catch((err) => {
        console.error("Failed to fetch profile:", err);
        setUser(null);
        localStorage.removeItem("isPremium");
      });
  };

  useEffect(() => {
    fetchUserProfile();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("isPremium");
    setUser(null);
    navigate("/");
  };

  return (
    <div className={`navbar ${lang === "bn" ? "bn-font" : ""}`}>
      <div className="navbar-title-container" onClick={() => navigate("/")}>
        <img
          className="navbar-title-img"
          src="/Assets/Logos/app_logo.png"
          alt="logo"
        />
        <div className="navbar-title">{translations[lang].title}</div>
      </div>

      <div className="navbar-button-container">
        {/* Language Toggle */}
        <div className="lang-switch">
          <label className="switch">
            <input
              type="checkbox"
              checked={lang === "bn"}
              onChange={handleLangToggle}
              title="Toggle language"
            />
            <span className="slider round">
              {lang === "bn" ? "বাংলা" : "English"}
            </span>
          </label>
        </div>

        {/* If user is logged in */}
        {user ? (
          <>
            <div
              className={`navbar-user-info ${
                user.is_premium ? "premium-user" : "regular-user"
              }`}
            >
              {translations[lang].hi}, {user.full_name || user.username}
            </div>

            {/* Premium status or upgrade button */}
            {user.is_premium ? (
              <div className="navbar-premium-status">
                👑 {lang === "bn" ? "প্রিমিয়াম অ্যাকাউন্ট" : "Premium Account"}
              </div>
            ) : (
              <button
                className="navbar-pricing-button"
                onClick={() => navigate("/pricing")}
              >
                {lang === "bn"
                  ? "প্রিমিয়ামে আপগ্রেড করুন"
                  : "Upgrade to Premium"}
              </button>
            )}

            <button className="navbar-logout-button" onClick={handleLogout}>
              {translations[lang].logout}
            </button>
          </>
        ) : (
          <>
            <button
              className="navbar-signup-button"
              onClick={() => navigate("/register")}
            >
              {translations[lang].signup}
            </button>
            <button
              className="navbar-login-button"
              onClick={() => navigate("/login")}
            >
              {translations[lang].login}
            </button>
            {/* <button
              className="navbar-pricing-button"
              onClick={() => navigate("/pricing")}
            >
              {lang === "bn"
                ? "প্রিমিয়ামে আপগ্রেড করুন"
                : "Upgrade to Premium"}
            </button> */}
          </>
        )}
      </div>
    </div>
  );
}

export default Navbar;
